
  import {
    CommonCeiling,
    Delegation,
    DelegationSunset
  } from '@/services/api/models'
  import { defineComponent } from 'vue'
  import moment from 'moment'
  export default defineComponent({
    name: 'DelegationSunsetCard',
    props: {
      event: {
        type: Object as () => DelegationSunset | undefined,
        required: true
      }
    },
    setup() {
      return { moment }
    }
  })
